import { LocalStorageService } from './../../_services/local-storage.service';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginService } from 'src/app/_services/login.service';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {

  backupProfileobj:any;
  profile_form: FormGroup;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  constructor(public modalService: NgbModal, private fb: FormBuilder,
    private _localstorageservice  :LocalStorageService,private _loginservice:LoginService) { }

  ngOnInit() {

    this.profile_form = this.fb.group({
      fname: [this.backupProfileobj ? this.backupProfileobj.firstname : '',Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]*$'),noWhitespaceValidator])],
      lname: [this.backupProfileobj ? this.backupProfileobj.lastname : '', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]*$'),noWhitespaceValidator])],
      emailid: [this.backupProfileobj ? { value: this.backupProfileobj.loginemail , disabled: true } : '', Validators.required],
      mobileno: [this.backupProfileobj ? this.backupProfileobj.extn : '', Validators.compose([Validators.required,Validators.pattern('^[+]?[0-9 ]*$'),Validators.minLength(10),Validators.maxLength(15)])],
      designation: [this.backupProfileobj ? this.backupProfileobj.designation : '', [Validators.required,noWhitespaceValidator]],
      cname: [this.backupProfileobj ? this.backupProfileobj.company : '', [Validators.required,noWhitespaceValidator]],
    })

    function noWhitespaceValidator(control: AbstractControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'required': true };
  }
  
  }

  saveDetails() {
    if (this.profile_form.valid) {
      let data ={
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "firstname": this.profile_form.value.fname,
        "lastname": this.profile_form.value.lname,
        "company": this.profile_form.value.cname,
        "designation": this.profile_form.value.designation,
        "extn": this.profile_form.value.mobileno,
      }

      let activity =[]
      let backupProfileobj = {
        "firstname": this.backupProfileobj.firstname,
        "lastname": this.backupProfileobj.lastname,
        "company": this.backupProfileobj.company,
        "designation": this.backupProfileobj.designation,
        "extn": this.backupProfileobj.extn
      }

      let result = Object.keys(backupProfileobj).filter(k => backupProfileobj[k] !== data[k]);
        result.map((elem, index) => {
          activity.push({
            updatedfieldname: "'" + elem + "'",
            oldvalue: "'" + backupProfileobj[elem] + "'",
            newvalue: "'" + data[elem] + "'"
          })
        })

        if(activity.length > 0){
          data['activitylog']=activity
        }

        if(activity.length>0){
          this._loginservice.updateuserDetails(data).subscribe((res:any)=>{
            if (res.status == "success") {
              this._localstorageservice.setItem('ufname', this.profile_form.value.fname)
              this._localstorageservice.setItem('ulname', this.profile_form.value.lname)
              this.modalService.dismissAll();
              this.passEntry.emit('success')
            }
            else {
              this.modalService.dismissAll();
              this.passEntry.emit('error')
  
            }
          })
        }else{
          this.modalService.dismissAll();
          this.passEntry.emit('success')
        }

        

    } else {
      this.validateAllFormFields(this.profile_form);

    }
  }


  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });

  }
}
